/**
 * 模型节点配置
 * 用于在模型选择弹窗中展示可用的模型
 */

export const MODEL_CONFIGS = {
  image: [
    {
      type: 'gptImage2',
      name: 'GPT 2 图像生成',
      description: '高精度图片生成与参考图编辑，最高 4K',
      tags: ['4K', '文字精准', '多图参考'],
      color: '#1463ff',
      icon: 'bi-stars',
    },
    {
      type: 'nanoBanana2',
      name: 'Nano 2 图像生成',
      description: '快速生成与多图参考，最高 4K',
      tags: ['快速', '14图参考', '最高4K'],
      color: '#16794d',
      icon: 'bi-lightning-charge',
    },
  ],

  video: [
    {
      type: 'minimaxH3Video',
      name: '海螺 H3 视频生成',
      description: '原生图片与视频多模态参考，支持 768P 与 2K',
      tags: ['9图+3视频', '2K', '4-15秒'],
      color: '#df4b2f',
      icon: 'bi-camera-reels',
    },
    {
      type: 'klingO3ReferenceVideo',
      name: '可灵 O3 视频生成',
      description: '图片与视频合计最多 4 个，支持原生音频与多镜头',
      tags: ['图/视频参考', '原生音频', '3-15秒'],
      color: '#2876d7',
      icon: 'bi-collection-play',
    },
    {
      type: 'geminiOmniFlashVideo',
      name: 'Gemini 极速视频生成',
      description: '快速文生视频与 1-5 张参考图生视频',
      tags: ['5图参考', '720P', '3-10秒'],
      color: '#6b4ad8',
      icon: 'bi-lightning-charge',
    },
    {
      type: 'superSeed2LiteVideo',
      name: 'Seedance 2.5 视频生成',
      description: 'Seedance 2.5 全能参考，支持图片、视频和音频素材',
      tags: ['Seedance 2.5', '图/视频/音频参考', '4-30秒'],
      color: '#13835e',
      icon: 'bi-stars',
    },
  ],

  audio: [
    {
      type: 'textToAudio',
      name: '语音合成',
      description: '海螺TTS语音合成',
      tags: ['多音色', '高质量'],
      color: '#fd7e14',
      icon: 'bi-mic',
    },
    {
      type: 'hailuoMusic',
      name: '音乐生成',
      description: '海螺AI音乐生成',
      tags: ['创作音乐', '多风格'],
      color: '#fd7e14',
      icon: 'bi-music-note-list',
    },
  ],
};

/**
 * 获取指定类型的模型配置
 * @param {string} mode - 模型类型: 'image' | 'video' | 'audio'
 * @returns {Array} 模型配置数组
 */
export const getModelsByMode = (mode) => {
  return MODEL_CONFIGS[mode] || [];
};

/**
 * 获取模型的默认数据
 * @param {string} modelType - 模型节点类型
 * @returns {Object} 默认数据对象
 */
export const getDefaultModelData = (modelType) => {
  const defaultDataMap = {
    // 图像模型
    gptImage2: { aspectRatio: '4:3', resolution: '1K', quality: 'low', outputFormat: 'png' },
    nanoBanana2: { aspectRatio: 'auto', resolution: '1K', numImages: 1, outputFormat: 'png' },
    imengImageGen: { prompt: '', mode: 'text2image' },
    minimaxImage: { prompt: '' },
    googleBanana: { prompt: '' },
    textToImage: { prompt: '' },
    referenceToImage: { prompt: '' },

    // 视频模型
    minimaxH3Video: { duration: 5, aspectRatio: '16:9', resolution: '768P' },
    klingO3ReferenceVideo: { duration: 5, aspectRatio: '16:9', resolution: 'Standard', generateAudio: true },
    geminiOmniFlashVideo: { duration: 5, aspectRatio: '16:9', resolution: '720P' },
    superSeed2LiteVideo: { duration: 6, aspectRatio: '16:9', resolution: '480p' },
    sora2Video: { prompt: '' },
    veo3Video: { prompt: '' },
    klingVideo: { prompt: '' },
    hailuo23Video: { prompt: '' },
    doubaoVideo: { prompt: '' },

    // 音频模型
    textToAudio: { text: '' },
    hailuoMusic: { prompt: '' },
  };

  return defaultDataMap[modelType] || {};
};

/**
 * 模型类型的显示名称映射
 */
export const MODEL_MODE_NAMES = {
  image: '图像模型',
  video: '视频模型',
  audio: '音频模型',
};
